import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useUpdatesDot } from "../lib/updates";
import { useSite } from "../lib/site";
import { isExternal } from "../lib/nav";

export default function Footer() {
  const { user } = useAuth();
  const site = useSite();
  const member = !!user && user.role !== "kid";
  const dot = useUpdatesDot(member);
  const links = site.footer_links || [];
  const linkCls = "hover:text-foreground transition-colors";
  return (
    <footer className="no-print mt-32 pb-10" data-testid="site-footer">
      {(member || links.length > 0) && (
        <nav className="max-w-6xl mx-auto px-6 mb-3 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-muted-foreground" aria-label="Footer">
          {member && (
            <Link to="/updates" className={`relative inline-flex items-center gap-1.5 ${linkCls}`} data-testid="footer-updates-link">
              What's new &amp; known issues
              {dot && <span className="h-1.5 w-1.5 rounded-full bg-[#FF375F]" data-testid="footer-updates-dot" />}
            </Link>
          )}
          {links.map((l, i) => (isExternal(l.url)
            ? <a key={i} href={l.url} target="_blank" rel="noreferrer" className={linkCls} data-testid={`footer-link-${i}`}>{l.label}</a>
            : <Link key={i} to={l.url} className={linkCls} data-testid={`footer-link-${i}`}>{l.label}</Link>))}
        </nav>
      )}
      <p className="max-w-6xl mx-auto px-6 text-center text-[11px] text-muted-foreground/70 tracking-tight" data-testid="footer-copyright">
        {site.footer_text || `© ${new Date().getFullYear()} ${site.site_name || "The Green House on E Ave"}. All rights reserved.`}
      </p>
    </footer>
  );
}
